import Icon from 'components/shared/icon';
import { useState } from 'react';
import RichText from 'components/shared/richtext';
import { keys, get, set } from 'lib/utils/sessionStorage';
import styles from './noKickbackfeePopup.module.scss';

const NoKickbackfeePopup = ({ globalModules, fees }) => {
  const { title, message, buttonText } = globalModules?.noKickbackfeePopup || {};
  const total = parseFloat(fees?.total || 0);
  const [open, setOpen] = useState(total === 0 && !get(keys.NO_KICKBACKFEE_POPUP));

  const handleClose = () => {
    document.body.style.overflow = 'auto';
    set(keys.NO_KICKBACKFEE_POPUP, true);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={() => {
            handleClose();
          }}
        >
          <Icon type="close" />
        </button>
        <div className={styles.title}>{title.text}</div>
        <RichText text={message?.text?.json} className={styles.message} />
        <button type="button" className={styles.buttonBlack} onClick={() => handleClose()}>
          {buttonText?.text}
        </button>
      </div>
    </div>
  );
};

export default NoKickbackfeePopup;
